



























































import Vue from 'vue'
// @ts-ignore
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'
import ProductObtainingGraph from '@/components/master-data/product/ProductObtainingGraph.vue'


interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  inSaveProgress: boolean

  artList: any[]
  art: number | null
  sicherheitsbestand: number | null
  maximalerbestan: number | null
  bestellmenge: number | null
  meldebestand: number | null
  verbrauchszeit: number | null
  sicherheitszeit: number | null
  dispositionbestand: number | null
  verbrauch: number | null
  lagerumschlag: number | null
  wertevom: string | null

  months: any[]
  months2: any[]
}

export default Vue.extend({
  name: 'ProductObtaining',

  components: {
    NumberField,
    ProductObtainingGraph
  },

  props: {
    productId: Number,
    selectedProductUnitId: Number,
    selectedLagerungenId: Number,
    storageMetaData: Object as () => any,
    storageData: Object as () => any,
    isCreate: Boolean,
    isUpdate: Boolean,
    loading: Boolean
  },

  data (): ComponentData {
    //const required = (value: any): boolean | string => !!value || ''

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      inSaveProgress: false,

      artList: [],
      art: null,
      sicherheitsbestand: null,
      maximalerbestan: null,
      bestellmenge: null,
      meldebestand: null,
      verbrauchszeit: null,
      sicherheitszeit: null,
      dispositionbestand: null,
      verbrauch: null,
      lagerumschlag: null,
      wertevom: null,

      months: [
        {id: 1, value: null, label: 'Jan'},
        {id: 2, value: null, label: 'Feb'},
        {id: 3, value: null, label: 'Mar'},
        {id: 4, value: null, label: 'Apr'},
        {id: 5, value: null, label: 'Mai'},
        {id: 6, value: null, label: 'Jun'},
        {id: 7, value: null, label: 'Jul'},
        {id: 8, value: null, label: 'Aug'},
        {id: 9, value: null, label: 'Sep'},
        {id: 10, value: null, label: 'Okt'},
        {id: 11, value: null, label: 'Nov'},
        {id: 12, value: null, label: 'Dez'},
      ],
      months2: [
        {id: 1, value: null, label: ''},
        {id: 2, value: null, label: ''},
        {id: 3, value: null, label: ''},
        {id: 4, value: null, label: ''},
        {id: 5, value: null, label: ''},
        {id: 6, value: null, label: ''},
        {id: 7, value: null, label: ''},
        {id: 8, value: null, label: ''},
        {id: 9, value: null, label: ''},
        {id: 10, value: null, label: ''},
        {id: 11, value: null, label: ''},
        {id: 12, value: null, label: ''},
      ]
    }
  },

  watch: {
    isCreate (newVal: boolean): void {
      if(newVal) {
        this.resetData()
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isUpdate (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    storageData (newVal: any): void {
      if(newVal) {
        this.setData()
      }
    },

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isReadonlyFields (): boolean {
      if(this.isCreate || this.isUpdate) {
        return false
      } else {
        return true
      }
    }
  },

  methods: {
    onSicherheitsbestandChange (): void {
      if(this.sicherheitsbestand == null || this.sicherheitsbestand < 0) {
        this.sicherheitsbestand = null
      }
    },
    onMaximalerbestanChange (): void {
      if(this.maximalerbestan == null || this.maximalerbestan < 0) {
        this.maximalerbestan = null
      }
    },
    onBestellmengeChange (): void {
      if(this.bestellmenge == null || this.bestellmenge < 0) {
        this.bestellmenge = null
      }
    },
    onMeldebestandChange (): void {
      if(this.meldebestand == null || this.meldebestand < 0) {
        this.meldebestand = null
      }
    },
    onVerbrauchszeitChange (): void {
      if(this.verbrauchszeit == null || this.verbrauchszeit < 0) {
        this.verbrauchszeit = null
      }
    },
    onSicherheitszeitChange (): void {
      if(this.sicherheitszeit == null || this.sicherheitszeit < 0) {
        this.sicherheitszeit = null
      }
    },
    onDispositionbestandChange (): void {
      if(this.dispositionbestand == null || this.dispositionbestand < 0) {
        this.dispositionbestand = null
      }
    },
    onVerbrauchChange (): void {
      if(this.verbrauch == null || this.verbrauch < 0) {
        this.verbrauch = null
      }
    },
    onLagerumschlagChange (): void {
      if(this.lagerumschlag == null || this.lagerumschlag < 0) {
        this.lagerumschlag = null
      }
    },

    onMonthChange (item: any): void {
      if(item.value == null || item.value < 0) {
        item.value = null
      } else if(item.value && item.value > 100) {
        item.value = 100
      }
    },


    onCancelClick (): void {
      this.setData()
      this.$emit('onCancelClick')
    },

    setData (): void {

    },

    resetData (): void {

    }
  },

  mounted () {
    this.setData()
  }

})
